App.controller('LifeStartCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', '$timeout', '$rootScope', 'popUpService', function ($scope, $sce, $state, $http, packageService, $stateParams, $timeout, $rootScope, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'life_start';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Ubezpieczenie na życie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    $timeout(function () {
        if (!$('.menu.menu_2').hasClass('open')) {
            $('a[target=".menu_2"]').trigger('click');
        }
    }, 0);

    if ($scope.stateParams.choose && $scope.stateParams.prices) {
        $scope.choose = $scope.stateParams.choose;
        $scope.prices = $scope.stateParams.prices;
        $scope.summary = $scope.stateParams.summary;
        $scope.persons = $scope.stateParams.persons;
    } else {
        $scope.summary = 0;
    }

    $scope.allLength = 0;
    $scope.groupwidth = [];
    $scope.singleLength = [];

    $scope.next = function () {
        $state.go('root.life.variant', {
            persons: $scope.persons,
            choose: $scope.choose,
            prices: $scope.prices,
            summary: $scope.summary
        });
    };

    var limitedPopupConfig = $rootScope.CONFIGURATOR.lifeInsurance.limitedTimePopup;
    if (limitedPopupConfig.limitedTimePopupEnabled) {
        var dateNow = moment().toDate();
        var dateTo = moment(limitedPopupConfig.limitedTimePopupDateTo).toDate();
        dateTo.setHours(23, 59, 59, 999);

        if (dateTo.getTime() <= dateNow.getTime()) return;

        var config = {
            head: limitedPopupConfig.limitedTimePopupHeading,
            content: limitedPopupConfig.limitedTimePopupContent,
            tpl: 'info-big'
        };

        popUpService.showPopUp(config);
    }
}]);
